import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ShapeSizeForm } from "@univdiam/ui/customComponents/ShapeSizeList/ShapesizeForm";
import api from "@/http/api";

export default function ShapeSizeEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    const fetchShapeSize = async () => {
      try {
        const response = await api.get(`/api/shape_size/${id}`);
        if (response.status === 200 && response.data) {
          const shape_size = response.data.data;
          console.log(shape_size);
          // Map fields to your form shape
          setInitialData({
            shape_size_id: shape_size.shape_size_id,
            shape: shape_size.shape,
            size: shape_size.size,
            wt: shape_size.wt,
            status: shape_size.status === 1 ? "1" : "0",
          });
        }
      } catch (err) {
        console.error("Failed to fetch group", err);
        alert("Error fetching group.");
        navigate("/shape-size");
      }
    };

    fetchShapeSize();
  }, [id, navigate]);

  const handleUpdateShapeSize = async (data: any) => {
    try {
      const response = await api.put(`/api/shape_size/${id}`, data);
      if (response.status === 200) {
        alert("ShapeSize updated successfully!");
        navigate("/shape-size");
      }
    } catch (error) {
      console.error("Error updating group:", error);
      alert("Failed to update group.");
    }
  };

  if (!initialData) return <p className="text-center p-10">Loading...</p>;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit ShapeSize</h1>
      <ShapeSizeForm
        onSubmit={handleUpdateShapeSize}
        initialValues={initialData}
        isEdit
      />
    </div>
  );
}
